export default __webpack_public_path__ + "static/media/lemon.b8c603f6.svg";